import { useCallback } from "react";
import { useLanguage } from "../../../../../stores/LanguageStore";
import { useDisclosure } from "@mantine/hooks";
import {
  ActionIcon,
  Button,
  Group,
  Modal,
  ThemeIcon,
  Tooltip,
} from "@mantine/core";
import { IconSparkles } from "@tabler/icons-react";
import QuickCampaignContent from "./QuickCampaignContent";

const QuickCampaign = ({ current, inMenu = false, closeMenu }) => {
  const lang = useLanguage((s) => s.language);
  const [opened, { open, close }] = useDisclosure();

  const handleClose = useCallback(() => {
    close();
    closeMenu?.();
  }, [close, closeMenu]);

  return (
    <>
      {inMenu ? (
        <Button
          onClick={open}
          justify="start"
          variant="light"
          w={"100%"}
          className="to-blue"
          size="md"
        >
          <Group gap={4}>
            <ThemeIcon variant="subtle" p={0}>
              <IconSparkles size={18} />
            </ThemeIcon>
            {lang.quick_campaign.button_label}
          </Group>
        </Button>
      ) : (
        <Tooltip label={lang.quick_campaign.text} ta={"center"}>
          <ActionIcon
            onClick={open}
            color="primary"
            variant="subtle"
            fw={500}
          >
            <IconSparkles size={22} fill="var(--mantine-color-primary-6)" />
          </ActionIcon>
        </Tooltip>
      )}

      {opened && (
        <Modal
          opened={opened}
          size={"70%"}
          onClose={handleClose}
          title={
            <Group>
              <ThemeIcon variant="subtle" color="primary">
                <IconSparkles fill="var(--mantine-color-primary-6)" />
              </ThemeIcon>
              {lang.quick_campaign.title}{" "}
              <b>
                {current?.name} #{current.id}
              </b>
            </Group>
          }
          styles={{
            title: {
              lineHeight: 1.5,
            },
          }}
        >
          <QuickCampaignContent handleClose={handleClose} current={current} />
        </Modal>
      )}
    </>
  );
};

export default QuickCampaign;
